module.exports = __webpack_public_path__ + "static/media/lab_test.fb02b8a9.png";